import { render } from "./UserSystemCreate.vue?vue&type=template&id=0a13461c"
import script from "./UserSystemCreate.vue?vue&type=script&lang=js"
export * from "./UserSystemCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__